export const TEACH_APP_URI =
  process.env.REACT_APP_TEACH_APP_URI || 'http://localhost:3000/#'
export const GEOLOCATION_URL =
  process.env.REACT_APP_GEOLOCATION_URL || 'https://staging.lalilo.com'
export const API_BASE_URI =
  process.env.REACT_APP_API_BASE_URI || 'http://localhost:8000'
export const MARKETO_BASE_URL =
  process.env.REACT_APP_MARKETO_BASE_URL || '//829-PJD-646.mktoweb.com'
export const MUNCHKIN_ID = process.env.REACT_APP_MUNCHKIN_ID || '829-PJD-646'
export const REQUEST_A_QUOTE_FORM_ID_EN =
  Number(process.env.REACT_APP_REQUEST_A_QUOTE_FORM_ID_EN) || 3851
export const REQUEST_A_QUOTE_FORM_ID_FR =
  Number(process.env.REACT_APP_REQUEST_A_QUOTE_FORM_ID_FR) || 3852
export const ENV = process.env.REACT_APP_ENV ?? 'local'

export const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID
export const GOOGLE_ANALYTICS_4_ID = process.env.REACT_APP_GA4_ID
export const GOOGLE_TAG_MANAGER_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID
export const LAUNCH_DARKLY_CLIENT_ID =
  process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID || '61d414ea54e5411520b8c84b'
export const LAUNCH_DARKLY_BASE_URL =
  process.env.REACT_APP_LAUNCH_DARKLY_BASE_URL
